<template>
  <div>
    <el-card v-if="loading">
      <i class="el-icon-loading"></i>
      資料載入中...
    </el-card>
    <el-card body-style="padding: 0" v-else>
      <div slot="header" class="card_header">
        <span>員工管理</span>
        <el-input
            style="width: 200px"
            v-model="search"
            size="mini"
            placeholder="搜尋"/>
      </div>
      <ezoom-table
          title="員工列表"
          :data="newEmployees"
          :search="search"
          :columns="columns"
      >
        <template slot="buttons">
          <el-button @click.stop="openEmpDialog({},'add')" type="primary"
                     size="small" icon="el-icon-plus">
            新增
          </el-button>
        </template>
        <el-table-column
            fixed="left"
            label="操作"
            width="270">
          <template slot-scope="scope">
            <el-button @click.stop="openEmpDialog(scope.row,'update')" type="warning"
                       size="small" icon="el-icon-edit"/>
            <el-popconfirm title="確定要刪除此員工嗎？"
                           @onConfirm="del(scope.row)"
                           @onCancel="()=>{}"
                           confirmButtonText="確定"
                           cancelButtonText="取消">
              <el-button @click.stop="" slot="reference" type="danger"
                         size="small" icon="el-icon-delete"/>
            </el-popconfirm>
            <el-popconfirm title="確定要解除綁定此員工嗎？"
                           @onConfirm="unbindUser(scope.row)"
                           @onCancel="()=>{}"
                           confirmButtonText="確定"
                           cancelButtonText="取消">
              <el-button @click.stop="" slot="reference" type="primary"
                         size="small" :disabled="!(scope.row.lineId)">
                解除綁定
              </el-button>
            </el-popconfirm>
            <el-button @click.stop="openEmpMsgDialog(scope.row)"
                       slot="reference" type="primary"
                       size="small" :disabled="!(scope.row.lineId)">
              發送訊息
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="employeeId" sortable label="員工編號" width="110"/>
        <el-table-column prop="employeeName" sortable label="姓名" width="100"/>
        <el-table-column prop="department" sortable label="部門" width="100"/>
        <el-table-column prop="label" sortable label="綁定狀態" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.lineId ? 'success' : 'warning'"
                    disable-transitions>
              {{ scope.row.lineId ? '已綁定' : '未綁定' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="report" sortable label="今日體溫回報">
          <template slot-scope="scope">
            <el-tag :type="scope.row.temperature ? 'success' : 'warning'"
                    disable-transitions>
              {{ scope.row.temperature ? '已回報' : '未回報' }}
            </el-tag>
          </template>
        </el-table-column>
      </ezoom-table>
    </el-card>
    <crud-employee
        v-if="dialogVisible"
        :type="type"
        :employee="employee"
        @handleClose="handleEmpClose"
        @add="add"
        @update="update"
    />
    <el-dialog
        :visible.sync="messageDialogVisible"
        title="發送訊息"
        width="400px">
      <el-button slot="footer" type="primary" icon="el-icon-s-platform"
                 @click.stop="sendMessage" :disabled="!this.msg">
        發送
      </el-button>
      <el-form style="text-align: left;font-size: 18px">
        <span v-if="messageDialogVisible">發送對象：{{ employee.employeeId }}-{{ employee.employeeName }}</span>
        <br> <br>
        <span style="font-size: 16px">請輸入要發送的訊息：</span>
        <el-input v-model="msg"/>
      </el-form>
    </el-dialog>
    <CrudCompany/>
  </div>
</template>

<script>
import EmployeeService from "../../api/employee.js";
import EzoomTable from "../../components/EzoomTable.vue";
import CrudEmployee from "./dialog/CrudEmployee.vue";
import CrudCompany from "./company/CrudCompany.vue";
import CompanyService from "@/api/company";
import {setNavTitle} from "@/views/useNavTitle";
import MessageService from "@/components/Message";
import {loading, search, init, openDialog} from "./company/useCompany.js";

export default {
  name: "Employee",
  components: {
    EzoomTable,
    CrudEmployee,
    CrudCompany
  },
  setup() {

    init()
          .then()
          .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
    return {search, loading, openDialog}
  },
  created() {
    const init = async () => {
      const companys = await CompanyService.list();
      this.companys = companys.map(company => ({
        ...company
      }));

      const employees = await EmployeeService.list(this.department);
      this.employees = employees.map(employee => ({
        ...employee,
        label: employee.lineId ? "已綁定" : "未綁定",
        report: employee.temperature ? "已回報" : "未回報"
      }));

      this.loading = false;
    };

    init()
      .then()
      .catch(e => console.error(e));
  },
  mounted() {
    setNavTitle("員工管理")
  },
  methods: {
    unbindUser(row) {
      const id = row.employeeId;

      EmployeeService.unbind(id)
          .then(() => {
            const index = this.employees.findIndex(
                item => item.employeeId === id
            );
            const employee = this.employees.find(item => item.employeeId === id);
            this.employees.splice(index, 1); // delete one element in array

            MessageService.success(`員工 : ${employee.employeeId} - ${employee.employeeName} 成功解除綁定 !`)
          })
          .catch(e => MessageService.error(`解除綁定失敗 , e= ${e}`));
    },
    add(employee) {
      EmployeeService.add(employee)
          .then(data => {
            this.employees.unshift(data);

            var company = this.companys.find(item => item.departmentNo === data.department);
            if (company) {
              MessageService.success(`成功新增：${data.employeeId}-${data.employeeName}`)
            } else {
              var tempCompany = {};
              tempCompany.companyNo = '';
              tempCompany.companyName = '';
              tempCompany.companyId = '';
              tempCompany.departmentNo = '';
              this.openDialog(tempCompany,'add', data.department);
            }

            this.dialogVisible = false;
          })
          .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
    },
    update(employee) {
      EmployeeService.update(employee)
          .then(data => {
            const index = this.employees.findIndex(
                emp => emp.employeeId === employee.employeeId
            );
            // 利用 vm.$set(array, index, value) 方法
            this.$set(this.employees, index, data);
            this.dialogVisible = false;

            MessageService.success(`成功新增：${data.employeeId}-${data.employeeName}`)
          })
          .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
    },
    del(row) {
      const id = row.employeeId;

      EmployeeService.deleteById(id)
          .then(() => {
            const index = this.employees.findIndex(emp => emp.employeeId === id);
            // 利用 arr.splice(startIndex, deleteCount)
            this.employees.splice(index, 1);
            MessageService.success(`成功刪除：${row.employeeId}-${row.employeeName}`)
          })
          .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
    },
    openEmpDialog(row, type) {
      this.employee = row;
      this.type = type;
      this.dialogVisible = true;
    },
    openEmpMsgDialog(row) {
      this.employee = row;
      this.messageDialogVisible = true;
    },
    handleEmpClose() {
      this.dialogVisible = false;
    },
    sendMessage() {
      const employee = this.employee;
      const employeeId = employee.employeeId;

      EmployeeService.sendMessage({employeeId, text: this.msg})
          .then(() => {
            this.messageDialogVisible = false;
            MessageService.success(`成功發送訊息：${this.msg} 給 ${employee.employeeId}-${employee.employeeName}`)
          })
          .catch(e => MessageService.error(`發送訊息失敗：${e.title} , ${e.message}`));
    }
  },
  data() {
    return {
      dialogVisible: false,
      messageDialogVisible: false,
      type: this.type,
      msg: this.msg,
      employee: this.employee,
      employees: this.employees,
      companys: this.companys,
      search: this.search,
      loading: true,
    };
  },
  computed: {
    department() {
      if (!this.$store.state.manager) return undefined;
      else if (this.$store.state.manager.level === "admin") return undefined;
      else return this.$store.state.manager.ownership;
    },
    newEmployees() {
      return this.employees.map(employee => ({
        ...employee,
        label: employee.lineId ? "已綁定" : "未綁定",
      }));
    },
    columns() {

      return [
        {label: "員工編號", prop: "employeeId"},
        {label: "姓名", prop: "employeeName"},
        {label: "部門", prop: "department"},
        {label: "綁定狀態", prop: "label"}
      ]
    }
  }
};
</script>

<style scoped>
</style>
